import React from 'react';
import PageLayout, { PageLayoutProps } from './PageLayout';

const OpenPageLayout = (props: PageLayoutProps) => {
  return <PageLayout {...props} />;
};

export default OpenPageLayout;
